import React from "react";
import { connect } from "react-redux";
import SizeItem from "./SizeItem";
import DarkOverlay from "../../../../Parts/DarkOverlay";
import { toggleSizeDropdown } from "../../../../Redux/slices/singleProduct";

const mapStateToProps = state => {
    return {
        visible: state.singleProduct.UI.showSizeDropdown
    };
};

class SizeDropdown extends React.Component {
  render() {
    const sizeOrderMap = {
      XS: 1,
      Small: 2,
      Medium: 3,
      Large: 4,
      XL: 5,
    };

    const sortedVariations = [...this.props.variations];

    sortedVariations.sort((a, b) => {
      const sizeA = a.attributes.nodes[0].value;
      const sizeB = b.attributes.nodes[0].value;

      const orderA = sizeOrderMap[sizeA] || 99;
      const orderB = sizeOrderMap[sizeB] || 99;

      return orderA - orderB;
    });

    const variations = sortedVariations.map((item, key) => (
      <SizeItem
        key={key}
        id={item.databaseId}
        price={item.price}
        value={item.attributes.nodes[0].value}
        stockStatus={item.stockStatus}
        selected={item.databaseId === this.props.variantId}
      />
    ));

    return (
      <DarkOverlay
        visible={this.props.visible}
        closeSelf={toggleSizeDropdown}
        className="size-dropdown-overlay"
      >
        <div className="size-dropdown-wrap transform-fade-y">
          <div className="head-wrap">
            <span className="title">Select size</span>
          </div>
          <div className="variations-wrap">{variations}</div>
        </div>
      </DarkOverlay>
    );
  }
}

export default connect(mapStateToProps)(SizeDropdown);